import { render, staticRenderFns } from "./SalesRole.vue?vue&type=template&id=24dd130c&scoped=true&"
import script from "./SalesRole.vue?vue&type=script&lang=js&"
export * from "./SalesRole.vue?vue&type=script&lang=js&"
import style0 from "./SalesRole.vue?vue&type=style&index=0&id=24dd130c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dd130c",
  null
  
)

export default component.exports